import { render, staticRenderFns } from "./ConfigureBundle.vue?vue&type=template&id=0edf3ec7&scoped=true"
import script from "./ConfigureBundle.vue?vue&type=script&lang=ts"
export * from "./ConfigureBundle.vue?vue&type=script&lang=ts"
import style0 from "./ConfigureBundle.vue?vue&type=style&index=0&id=0edf3ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf3ec7",
  null
  
)

export default component.exports